

import React from "react";
import {Jumbotron} from "reactstrap";

const Row5 = () => {
    return(
        <div>
            <br/><br/>
      <hr/>
    <Jumbotron className="jumbobg1">
        <div></div>
      </Jumbotron>
      <hr/>
      </div>
      );
        
    
}

export default Row5;